import MenuItem from "@/lib/menu/MenuItem";
import MenuGroup from "@/lib/menu/MenuGroup";
import MenuSet from "@/lib/menu/MenuSet";

export const PAGE = Object.freeze({
  PATIENT: 'patient',
  PATIENT_MONITORS: 'patientMonitors',
  ASSIGNMENTS: 'assignments',
  CENTRAL_MONITORING: 'centralMonitoring',
  INFINITY_WATCH: 'infinityWatch',
  TEAM_MODE: 'teamMode',
  NURSING_STATION: 'nursingStation',
  SHIFT_REPORT: 'shiftReport',
  PATIENT_TRACKER: 'patientTracker',
  OPERATIONAL_LIVE_VIEW: 'operationalLiveView',
  PATIENT_TIMELINE: 'patientTimeline',
  ADVANCED_REPORTING: 'advancedReporting',
  RECORDINGS: 'recordings',
  CARE_ASSIGNMENTS: 'careAssignments',
  MY_HOME: 'myHome'
})

export const PAGE_LINK = Object.freeze({
  [PAGE.PATIENT]: { name: 'patients.index' },
  [PAGE.PATIENT_MONITORS]: { name: 'patient-monitors.index' },
  [PAGE.CENTRAL_MONITORING]: { name: 'patient-central' },
  [PAGE.ASSIGNMENTS]: { name: 'manager-view' },
  [PAGE.INFINITY_WATCH]: { name: 'infinity-watch' },
  [PAGE.TEAM_MODE]: { name: 'patient-central.team-mode' },
  [PAGE.NURSING_STATION]: { name: 'patient-central.nursing-station' },
  [PAGE.SHIFT_REPORT]: { name: 'reporting.shift-report' },
  [PAGE.PATIENT_TRACKER]: { name: 'patient-tracker' },
  [PAGE.OPERATIONAL_LIVE_VIEW]: { name: 'operational-live-view' },
  [PAGE.PATIENT_TIMELINE]: { name: 'timeline' },
  [PAGE.ADVANCED_REPORTING]: { name: 'advanced-reporting' },
  [PAGE.RECORDINGS]: { name: 'recordings' },
  [PAGE.CARE_ASSIGNMENTS]: { name: 'care-assignments' },
  [PAGE.MY_HOME]: { name: 'my-assignments' }
})

export const PAGE_TYPE = Object.freeze({
  TABLE: 'table',
  CENTRAL_MONITORING: 'centralMonitoring',
  ASSIGNMENTS: 'assignments',
  GROUP: 'group',
  INFINITY_WATCH: 'infinityWatch',
  TEAM_MODE: 'teamMode',
  NURSING_STATION: 'nursingStation',
  SHIFT_REPORT: 'shiftReport',
  PATIENT_TRACKER: 'patientTracker',
  OPERATIONAL_LIVE_VIEW: 'operationalLiveView',
  PATIENT_TIMELINE: 'patientTimeline',
  ADVANCED_REPORTING: 'advancedReporting',
  RECORDINGS: 'recordings',
  CARE_ASSIGNMENTS: 'careAssignments'
})

export const PAGE_CONFIG = Object.freeze({
  [PAGE.SHIFT_REPORT]: {
    page: PAGE.SHIFT_REPORT,
    pageType: PAGE_TYPE.SHIFT_REPORT,
  },
  [PAGE.PATIENT]: {
    page: PAGE.PATIENT,
    pageType: PAGE_TYPE.TABLE,
    tableId: 'patients-list',
    customFieldsModel: 'Patient'
  },
  [PAGE.PATIENT_MONITORS]: {
    page: PAGE.PATIENT_MONITORS,
    pageType: PAGE_TYPE.TABLE,
    tableId: 'patient-monitors-list',
    customFieldsModel: 'PatientMonitor'
  },
  [PAGE.CENTRAL_MONITORING]: {
    page: PAGE.CENTRAL_MONITORING,
    pageType: PAGE_TYPE.CENTRAL_MONITORING,
  },
  [PAGE.ASSIGNMENTS]: {
    page: PAGE.ASSIGNMENTS,
    pageType: PAGE_TYPE.ASSIGNMENTS,
  },
  [PAGE.GROUP]: {
    pageType: PAGE_TYPE.GROUP,
  },
  [PAGE.INFINITY_WATCH]: {
    page: PAGE.INFINITY_WATCH,
    pageType: PAGE_TYPE.INFINITY_WATCH,
  },
  [PAGE.TEAM_MODE]: {
    page: PAGE.TEAM_MODE,
    pageType: PAGE_TYPE.TEAM_MODE,
  },
  [PAGE.NURSING_STATION]: {
    page: PAGE.NURSING_STATION,
    pageType: PAGE_TYPE.NURSING_STATION,
  },
  [PAGE.PATIENT_TRACKER]: {
    page: PAGE.PATIENT_TRACKER,
    pageType: PAGE_TYPE.PATIENT_TRACKER,
  },
  [PAGE.OPERATIONAL_LIVE_VIEW]: {
    page: PAGE.OPERATIONAL_LIVE_VIEW,
    pageType: PAGE_TYPE.OPERATIONAL_LIVE_VIEW,
  },
  [PAGE.PATIENT_TIMELINE]: {
    page: PAGE.PATIENT_TIMELINE,
    pageType: PAGE_TYPE.PATIENT_TIMELINE,
  },
  [PAGE.ADVANCED_REPORTING]: {
    page: PAGE.ADVANCED_REPORTING,
    pageType: PAGE_TYPE.ADVANCED_REPORTING,
  },
  [PAGE.RECORDINGS]: {
    page: PAGE.RECORDINGS,
    pageType: PAGE_TYPE.RECORDINGS,
  },
  [PAGE.CARE_ASSIGNMENTS]: {
    page: PAGE.CARE_ASSIGNMENTS,
    pageType: PAGE_TYPE.CARE_ASSIGNMENTS,
  },
  [PAGE.MY_HOME]: {
    page: PAGE.MY_HOME,
    pageType: PAGE_TYPE.TABLE,
    tableId: 'my-assignments-list',
    customFieldsModel: 'Patient',
    tableIdForFilters: 'patient'
  }
})

export const AVAILABLE_ITEMS = [
  {
    type: 'menu',
    title: 'Group',
    icon: 'mdi-group',
    config: PAGE_CONFIG[PAGE.GROUP]
  },
  {
    type: 'menu',
    title: 'Patients List',
    config: PAGE_CONFIG[PAGE.PATIENT],
    label: 'Patients',
    icon: 'mdi-human-queue'
  },
  {
    type: 'menu',
    title: 'Patients Monitors',
    config: PAGE_CONFIG[PAGE.PATIENT_MONITORS],
    label: 'Patient Monitors',
    icon: 'mdi-access-point'
  },
  {
    type: 'menu',
    title: 'Central Monitoring',
    config: PAGE_CONFIG[PAGE.CENTRAL_MONITORING],
    label: 'Central Monitoring',
    icon: 'mdi-doctor'
  },
  {
    type: 'menu',
    title: 'Assignments',
    config: PAGE_CONFIG[PAGE.ASSIGNMENTS],
    label: 'Assignments',
    icon: 'mdi-account-switch'
  },
  {
    type: 'menu',
    title: 'Infinity Watch',
    config: PAGE_CONFIG[PAGE.INFINITY_WATCH],
    label: 'Infinity Watch',
    icon: 'mdi-infinity'
  },
  {
    type: 'menu',
    title: 'Team Mode',
    config: PAGE_CONFIG[PAGE.TEAM_MODE],
    label: 'Team Mode',
    icon: 'mdi-account-group'
  },
  {
    type: 'menu',
    title: 'Nursing Station',
    config: PAGE_CONFIG[PAGE.NURSING_STATION],
    label: 'Nursing Station',
    icon: 'mdi-monitor-star'
  },
  {
    type: 'menu',
    title: 'Shift Report',
    config: PAGE_CONFIG[PAGE.SHIFT_REPORT],
    label: 'Shift Report',
    icon: 'mdi-file-document-outline'
  },
  {
    type: 'menu',
    title: 'Patient Tracker',
    config: PAGE_CONFIG[PAGE.PATIENT_TRACKER],
    label: 'Patient Tracker',
    icon: 'mdi-clipboard-text-clock'
  },
  {
    type: 'menu',
    title: 'Operational Live View',
    config: PAGE_CONFIG[PAGE.OPERATIONAL_LIVE_VIEW],
    label: 'Operational Live View',
    icon: 'mdi-monitor-eye'
  },
  {
    type: 'menu',
    title: 'Patient Timeline',
    config: PAGE_CONFIG[PAGE.PATIENT_TIMELINE],
    label: 'Patient Timeline',
    icon: 'mdi-calendar-clock-outline'
  },
  {
    type: 'menu',
    title: 'Advanced Reporting',
    config: PAGE_CONFIG[PAGE.ADVANCED_REPORTING],
    label: 'Platform Analytics',
    icon: 'mdi-google-analytics'
  },
  {
    type: 'menu',
    title: 'Recordings',
    config: PAGE_CONFIG[PAGE.RECORDINGS],
    label: 'Video Recordings',
    icon: 'mdi-file-video-outline'
  },
  {
    type: 'menu',
    title: 'Care Assignments',
    config: PAGE_CONFIG[PAGE.CARE_ASSIGNMENTS],
    label: 'Care Assignments',
    icon: 'mdi-file-tree-outline'
  },
  {
    type: 'menu',
    title: 'My Home',
    config: PAGE_CONFIG[PAGE.MY_HOME],
    label: 'My Home',
    icon: 'mdi-home-account'
  }
];

const permissions = {
  canViewManagePatients() { return this.$can('View', 'Patient') },
  canViewMonitoring() { return this.$can('View', 'PatientMonitor') },
  canViewPatientCentral() { return this.$can('View', 'PatientCentral') },
  canViewReporting() { return this.$can('View', 'Reporting') },
  canViewManagementReporting() { return this.$can('ViewManagement', 'Reporting') },
  canExportReporting() { return this.$can('Export', 'Reporting') },
  canViewHospital() { return this.$can('View', 'Hospital') },
  canViewRooms() { return this.$can('View', 'Room') },
  canViewUnits() { return this.$can('View', 'Unit') },
  canViewVideoDevices() { return this.$can('View', 'VideoDevice') },
  canViewUsers() { return this.$can('View', 'User') },
  canViewRoles() { return this.$can('View', 'Role')},
  canViewGroup() { return this.$can('View', 'Group') },
  canViewLogs() { return this.$can('View', 'AuditLog') },
  canViewFormBuilder() { return this.$can('Edit', 'FormBuilder') },
  canViewAccessBrowser() { return this.$can('View', 'User') && this.$can('View', 'Group') && this.$can('View', 'Room') && this.$can('View', 'Unit') },
  canManageSharedViews() { return this.$can('ManageSharedViews', 'PatientCentral') },
  canViewDivisions() { return this.$can('View', 'Division') },
  canEditDivision() { return this.$can('Edit', 'Division') },
  canViewSystemMonitoring() { return this.$can('View', 'SystemMonitoring') },
  canManageLabelers() { return this.$can('Manage', 'Labeler') },
  canEditLabeling() { return this.$can('Edit', 'LabeledImage') },
  canEditHomepage() { return this.$can('Edit', 'Homepage') },
  canEditHospital() { return this.$can('Edit', 'Hospital') },
  canManageHospital() { return this.$can('Manage', 'Hospital')},
  canManageSystem() { return this.$can('Manage', 'System') },
  canEditAimeePrompts() { return this.$can('Edit', 'AimeePrompt') },
  canUseAimeeChat() { return this.$can('Use', 'AimeeChat') },
  canViewAimeeConversations() { return this.$can('View', 'AimeeConversation') },
  canManageAssignments() { return this.$can('Manage', 'PatientMonitorAssignment') },
  canManageOrViewAssignments() { return this.$can('Manage', 'PatientMonitorAssignment') || this.$can('View', 'PatientMonitorAssignment') },
  canReceiveAssignments() { return this.$can('Receive', 'PatientMonitorAssignment') },
  canViewInfinityWatch() { return this.$can('View', 'InfinityWatch') },
  canViewRecordings() { return this.$can('View', 'Recording') },
  canViewPartners() { return this.$can('Manage', 'System') },
  isNotVirtualObserverAndCanViewAssignments() {
    const staffTypes = this.$store.state.currentUser?.staff_types || []
    return staffTypes.some(type => type.kind != 'virtual_observer') && this.$can('View', 'PatientMonitorAssignment')
  },
}

function evaluatePermission(permFunc) {
  return permFunc.call(this)
}

export const PAGE_PERMISSION = Object.freeze({
  [PAGE.PATIENT]: permissions.canViewManagePatients,
  [PAGE.PATIENT_MONITORS]: permissions.canViewMonitoring,
  [PAGE.CENTRAL_MONITORING]: permissions.canViewPatientCentral,
  [PAGE.ASSIGNMENTS]: permissions.canManageOrViewAssignments,
  [PAGE.INFINITY_WATCH]: permissions.canViewInfinityWatch,
  [PAGE.TEAM_MODE]: permissions.canReceiveAssignments,
  [PAGE.NURSING_STATION]: permissions.canViewPatientCentral,
  [PAGE.SHIFT_REPORT]: permissions.canViewReporting,
  [PAGE.PATIENT_TRACKER]: permissions.canManageOrViewAssignments,
  [PAGE.OPERATIONAL_LIVE_VIEW]: permissions.canViewReporting,
  [PAGE.PATIENT_TIMELINE]: permissions.canViewReporting,
  [PAGE.ADVANCED_REPORTING]: permissions.canViewManagementReporting,
  [PAGE.RECORDINGS]: permissions.canViewRecordings,
  [PAGE.CARE_ASSIGNMENTS]: permissions.canManageOrViewAssignments,
  [PAGE.MY_HOME]: permissions.isNotVirtualObserverAndCanViewAssignments
})

export function buildHomeMenuSet() {
  return [
    new MenuItem(null, 'Home', { name: 'home' }, true, 'mdi-home')
  ]
}

export function buildStaticMenuSets(appInstance) {
  const permEval = evaluatePermission.bind(appInstance)
  const healthSystem = new MenuGroup('Health System', 'mdi-layers-outline')
  healthSystem.enabled = permEval(permissions.canViewHospital) || permEval(permissions.canManageSharedViews) || permEval(permissions.canViewDivisions) || permEval(permissions.canViewFormBuilder) || permEval(permissions.canEditHospital)
  healthSystem.children = [
    new MenuItem(null, 'Action Templates', { name: 'form-builder' }, true, 'mdi-table-cog', permEval(permissions.canViewFormBuilder)),
    new MenuItem(null, 'ADT Rules', { name: 'hsl.adt-rules.index' }, true, 'mdi-file-chart-outline', permEval(permissions.canManageHospital)),
    new MenuItem(null, 'Attributes', { name: 'hsl.tags' }, true, 'mdi-tag-multiple-outline', permEval(permissions.canViewHospital)),
    new MenuItem(null, 'Column Transformers', { name: 'hsl.column-transformers.index' }, true, 'mdi-palette-swatch', permEval(permissions.canEditHospital)),
    new MenuItem(null, 'Custom Fields', { name: 'hsl.custom-fields.index' }, true, 'mdi-form-textbox', permEval(permissions.canViewHospital)),
    new MenuItem(null, 'Dynamic Fields', { name: 'hsl.dynamic-fields.index' }, true, 'mdi-playlist-edit', permEval(permissions.canViewHospital)),
    new MenuItem(null, 'Hospitals', { name: 'hsl.hospitals.index' }, true, 'mdi-hospital-building', permEval(permissions.canViewDivisions)),
    new MenuItem(null, 'Page Preferences', { name: 'hsl.page_preferences.index' }, true, 'mdi-page-layout-header-footer', permEval(permissions.canEditHospital)),
    new MenuItem(null, 'Recording Rules', { name: 'hsl.recording-rules.index' }, true, 'mdi-camera-timer', permEval(permissions.canManageHospital)),
    new MenuItem(null, 'Schedules', { name: 'hsl.schedules.index' }, true, 'mdi-calendar-clock', permEval(permissions.canManageHospital)),
    new MenuItem(null, 'Staff Types', { name: 'hsl.staff-types.index' }, true, 'mdi-account-group-outline', permEval(permissions.canViewHospital)),
    new MenuItem(null, 'Video Reasons', { name: 'hsl.video-reasons.index' }, true, 'mdi-checkbox-multiple-marked', permEval(permissions.canViewHospital)),
    new MenuItem(null, 'Views', { name: 'hsl.manage-views' }, true, 'mdi-view-list-outline', permEval(permissions.canManageSharedViews)),
    new MenuItem(null, 'Virtual Request Types', { name: 'virtual-request-types' }, true, 'mdi-message-text-outline', permEval(permissions.canManageHospital)),
    new MenuItem(null, 'Preferences', { name: 'hsl.preferences' }, true, 'mdi-dns-outline', permEval(permissions.canViewHospital)),
  ]

  const hospital = new MenuGroup('Hospitals', 'mdi-hospital-building')
  hospital.enabled = permEval(permissions.canViewRooms) || permEval(permissions.canViewUnits) || permEval(permissions.canViewVideoDevices) || permEval(permissions.canEditHomepage) || permEval(permissions.canEditDivision)
  hospital.children = [
    new MenuItem(null, 'Homepage', { name: 'hospital.homepage' }, true, 'mdi-home-edit-outline', permEval(permissions.canEditHomepage)),
    new MenuItem(null, 'Rooms', { name: 'hospital.rooms' }, true, 'mdi-puzzle-outline', permEval(permissions.canViewRooms)),
    new MenuItem(null, 'Units', { name: 'hospital.units' }, true, 'mdi-vector-intersection', permEval(permissions.canViewUnits)),
    new MenuItem(null, 'Video Devices', { name: 'hospital.video_devices' }, true, 'mdi-cctv', permEval(permissions.canViewVideoDevices)),
    new MenuItem(null, 'Preferences', { name: 'hospital.preferences' }, true, 'mdi-dns-outline', permEval(permissions.canEditDivision)),
  ]

  const userManagement = new MenuGroup('User Management', 'mdi-account-group-outline')
  userManagement.enabled = permEval(permissions.canViewUsers) || permEval(permissions.canViewRoles) || permEval(permissions.canViewGroup) || permEval(permissions.canViewAccessBrowser) || permEval(permissions.canManageLabelers)
  userManagement.children = [
    new MenuItem(null, 'Access Browser', { name: 'user-management.access-browser' }, true, 'mdi-magnify-scan', permEval(permissions.canViewAccessBrowser)),
    new MenuItem(null, 'Groups', { name: 'user-management.groups' }, true, 'mdi-group', permEval(permissions.canViewGroup)),
    new MenuItem(null, 'Guests', { name: 'user-management.guests' }, true, 'mdi-account-arrow-right-outline', permEval(permissions.canViewUsers)),
    new MenuItem(null, 'Roles', { name: 'user-management.roles' }, true, 'mdi-account-key-outline', permEval(permissions.canViewRoles)),
    new MenuItem(null, 'Users', { name: 'user-management.users' }, true, 'mdi-account-group-outline', permEval(permissions.canViewUsers)),
  ]

  const labeling = new MenuGroup('Labeling', 'mdi-label-multiple')
  labeling.enabled = permEval(permissions.canEditLabeling) || permEval(permissions.canManageLabelers)
  labeling.children = [
    new MenuItem(null, 'Label Images', { name: 'labeling.index' }, true, 'mdi-draw', permEval(permissions.canEditLabeling)),
    new MenuItem(null, 'Labeling Users', { name: 'user-management.labelersindex' }, true, 'mdi-tag-multiple-outline', permEval(permissions.canManageLabelers)),
    new MenuItem(null, 'Delete Labeled Image', { name: 'labeling.delete-image' }, true, 'mdi-image-remove', permEval(permissions.canManageLabelers)),
  ]

  const monitoring = new MenuGroup('Monitoring', 'mdi-monitor-dashboard')
  monitoring.enabled = permEval(permissions.canViewLogs) || permEval(permissions.canViewSystemMonitoring) || permEval(permissions.canViewReporting)
  monitoring.children = [
    new MenuItem(null, 'ADT Messages', { name: 'monitoring.adt-messages' }, true, 'mdi-card-bulleted-outline', permEval(permissions.canViewLogs)),
    // new MenuItem(null, 'Device Uptime', { name: 'monitoring.devices-uptime' }, true, 'mdi-alarm-light-outline', permEval(permissions.canViewSystemMonitoring)),
    new MenuItem(null, 'Inbound Requests', { name: 'monitoring.inbound-requests' }, true, 'mdi-import', permEval(permissions.canViewLogs)),
    new MenuItem(null, 'Logs', { name: 'monitoring.logs' }, true, 'mdi-format-columns', permEval(permissions.canViewLogs)),
    new MenuItem(null, 'Monitor Connections', { name: 'monitoring.monitor-connections' }, true, 'mdi-connection', permEval(permissions.canViewLogs)),
    new MenuItem(null, 'Nurse Call', { name: 'monitoring.nurse-call' }, true, 'mdi-phone-outline', permEval(permissions.canViewLogs)),
    new MenuItem(null, 'Nurse Call Downtimes', { name: 'monitoring.nurse-call-downtimes' }, true, 'mdi-phone-off', permEval(permissions.canEditHospital)),
    new MenuItem(null, 'System Overview', { name: 'monitoring.system-overview' }, true, 'mdi-view-dashboard-variant-outline', permEval(permissions.canViewSystemMonitoring)),
  ]

  const system = new MenuGroup('System', 'mdi-cog-outline')
  system.enabled = permEval(permissions.canManageSystem) || permEval(permissions.canViewReporting) || permEval(permissions.canExportReporting) || permEval(permissions.canViewAimeeConversations) || permEval(permissions.canEditAimeePrompts) || permEval(permissions.canUseAimeeChat)
  system.children = [
    new MenuItem(null, 'Aimee Chat', { name: 'aimee-chat' }, true, 'mdi-chat', permEval(permissions.canUseAimeeChat)),
    new MenuItem(null, 'Aimee Conversations', { name: 'system.aimee-conversations' }, true, 'mdi-record-circle', permEval(permissions.canViewAimeeConversations)),
    new MenuItem(null, 'Aimee Prompts', { name: 'hsl.aimee-prompts.index' }, true, 'mdi-account-voice', permEval(permissions.canEditAimeePrompts)),
    new MenuItem(null, 'App Modules', { name: 'menu-management' }, true, 'mdi-menu', permEval(permissions.canManageSystem)),
    new MenuItem(null, 'Background Jobs', { name: 'system.background-jobs' }, true, 'mdi-cog-transfer', permEval(permissions.canManageSystem)),
    new MenuItem(null, 'Data Export', { name: 'reporting.data-export' }, true, 'mdi-database-export', permEval(permissions.canExportReporting)),
    new MenuItem(null, 'Feature Flags', { name: 'system.feature-flags' }, true, 'mdi-flag-variant-outline', permEval(permissions.canManageSystem)),
    new MenuItem(null, 'Partner API', { name: 'system.partners' }, true, 'mdi-api', permEval(permissions.canViewPartners)),
    new MenuItem(null, 'Test ADT Feed', { name: 'system.test-adt' }, true, 'mdi-database-import', permEval(permissions.canManageSystem)),
  ]

  const adminSet = new MenuSet(Math.random(), 'Admin', 'mdi-tune')
  adminSet.isExpanded = import.meta.env.VITE_ENVIRONMENT_NAME.startsWith('local')
  adminSet.children = [
    healthSystem,
    hospital,
    userManagement,
    labeling,
    monitoring,
    system,
  ]

  return [adminSet]
}